import React from "react";
import classNames from "classnames";
import {observer} from 'mobx-react';
import styles from "../../styles/competitor-players-stats-module.module.scss";
import {COMPETITOR_PLAYER_STATS} from "../../competitor-players-stats-module.consts";

export const CompetitorPlayersStatsModuleShot = observer(({controller, shot, width, height}) => {
  const {state} = controller;
  const {game: {homeCompetitor, awayCompetitor}} = state;

  const shotMarkClassName: String = shot.isMadeShot ? styles.made : styles.miss;
  const color: String = shot.isHomeCompetitor ? homeCompetitor.color : awayCompetitor.color;
  const shotMarkInlineStyle: Object = shot.isMadeShot ? {backgroundColor: color} : {borderColor: color};

  const sideOffset: Number = (height / COMPETITOR_PLAYER_STATS.SHOT_CHARTS_OFFSET.COURT_DIVIDER) *  COMPETITOR_PLAYER_STATS.SHOT_CHARTS_OFFSET.HALF_COURT_SIDE;
  const lineOffset: Number = (width / COMPETITOR_PLAYER_STATS.SHOT_CHARTS_OFFSET.COURT_DIVIDER) * COMPETITOR_PLAYER_STATS.SHOT_CHARTS_OFFSET.COURT_WITHOUT_OUTLINES;

  const shotProps = {
    className: classNames(styles.shot_court, styles.shot_mark, shotMarkClassName),
    style: {
      left: shot.line * lineOffset,
      top: shot.side * sideOffset,
      ...shotMarkInlineStyle
    }
  }

  return <div key={shot.key} {...shotProps}/>
});